import { Adicional } from "../Emisor/Adicional";
import { CertificacionPrecio } from "./CertificacionPrecio";
import * as moment from "moment";

export interface SolicitudCalculoPlan {
	idPlan: string;
	meses: number;
	codigoCupon: string;
	fa: boolean;
	fe: boolean;
	bo: boolean;
	gu: boolean;
	co: boolean;
	ex: boolean;
	li: boolean;
	adicionalPdf: Adicional;
	adicionalRecibidos: Adicional;
	adicionalPayku: Adicional;
	fechaDesde: string;
	conProporcional: boolean;
	idPlanNuevo?: string;
	mesesNuevo?: number;
	totalCertificadoDigital?: number;
	abono?: number;
}

export class Resumen {
	public cotizacionId?: string;
	public tipoCambio?: string;
	public permitido?: boolean;
	public motivoRechazo?: string;
	public descuentoPorc: number;
	public descuento: number;
	public abono?: number;
	public neto: number;
	public iva: number;
	public subtotal: number;
	public total: number;
	public meses: number;
	public totalPlanes: number;
	public formaPago: string;
	public totalCertificaciones: number;
	public totalAdicionales: number;
	public pagado: boolean;
	public proporcional: number;

	public nombrePlan: string;
	public tipoCertificacion: string;

	public fechaTermino: Date;
	public fechaInicioProporcional: Date;
	public totalCertificadoDigital!: number;
	public idPlanSf: string;
	public idDatosFacturacion: string;
	public idUsuario: string;
	public idEmisor: string;
	public idPlanUsuario: string;
	public idPlanUsuarioAntiguo?: string;
	public idContratacion: string;
	public codigoCupon: string;
	public extend: boolean; //Para indicar si extenderá el plan
	public change: boolean; //Para indicar si cambiará el plan
	public payment: boolean; //Para indicar si está pagando atrasado
	public certificaciones: CertificacionPrecio[];
	public adicionales: Adicional[];

	public differenceInDays: number;
	public esReactivacion?: boolean;
	/**
	 *
	 */
  	public mesesAbono?: number;
  	public descripcionAbono?: string;
  	public fechaInicioAbono?: moment.Moment;
  	public fechaTerminoAbono?: moment.Moment;
	public fechaConfirmada: Date;
	public usarSaldoFavor: boolean;
	public saldoAplicadoEsperado: number;
	public solicitudCalculo: SolicitudCalculoPlan;
	constructor() {
		this.descuentoPorc = 0;
		this.pagado = false;
		this.descuento = 0;
		this.neto = 0;
		this.iva = 0;
		this.subtotal = 0;
		this.total = 0;
		this.meses = 6;
		this.totalPlanes = 0;
		this.formaPago = "webpay";
		this.totalAdicionales = 0;
		this.totalCertificaciones = 0;
		this.totalCertificadoDigital= 0;
		this.abono = 0;
		this.usarSaldoFavor = false;
		this.saldoAplicadoEsperado = 0;
    	this.mesesAbono = 0;
    	this.descripcionAbono = '';
    	this.fechaInicioAbono = null;
    	this.fechaTerminoAbono = null;
	}
}
